import { translationsSlice } from '../reducers/translations.reducers'

export const { initTranslations } = translationsSlice.actions
